import React from "react";

// Marks a queue row that the hourly Haiku capture check (dww-api-2
// src/queue_check) found differs only because some captures broke — a lazy
// image that never loaded, a page cut short. The company queues list these last.
// `summary` is the check's one line on what broke.
const ProbablyNotTestBadge = ({ summary, className = "" }) => (
  <span
    className={`dib dark-gray bg-light-yellow fw6 br1 ${className}`}
    style={{
      fontSize: "0.8em",
      padding: "0 0.4em",
      lineHeight: 1.5,
      verticalAlign: "middle",
    }}
    title={
      summary
        ? `Haiku capture check: ${summary}`
        : "Haiku capture check: the screens differ only because some captures broke"
    }
  >
    Probably not a test
  </span>
);

export default ProbablyNotTestBadge;
